// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addTheme {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  margin: 10% 32%;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.addTheme .titre {
  color: #333;
  font-size: 30px;
  font-family: "Times New Roman", Times, serif;
}
.addTheme .form-theme form {
  display: flex;
  flex-direction: column;
}
.addTheme .form-theme form Button {
  color: #fefefe;
  background: #2b2b81;
  padding: 10px 30px;
  margin: 10px;
  font-weight: bold;
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Theme/CreateTheme/addTheme.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,4CAAA;AACJ;AAII;EACE,aAAA;EACA,sBAAA;AAFN;AAIM;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAFR","sourcesContent":[".addTheme{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;\n  margin: 10% 32%;\n  padding: 25px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n  .titre{\n    color: #333;\n    font-size: 30px;\n    font-family: 'Times New Roman', Times, serif;\n  }\n\n  .form-theme{\n\n    form{\n      display: flex;\n      flex-direction: column;\n\n      Button{\n        color:  #fefefe;\n        background: #2b2b81;\n        padding: 10px 30px;\n        margin: 10px;\n        font-weight: bold;\n        border-radius: 20px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
